import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TablePrizeItemType, useGetPrizeListQuery } from 'entities/prize';
import { columnConfig } from 'widgets/prize/model';
import { useDefaultPrizeTableValues } from 'widgets/prize/lib';
import { DataTableBackendPagination } from 'shared/ui/Table';

export const PrizesTable = () => {
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    rowsPerPage: 5,
    page: 0,
  });

  const { data: prizes } = useGetPrizeListQuery({
    size: pagination.rowsPerPage,
    page: pagination.page + 1,
  });

  const tableData = useDefaultPrizeTableValues(prizes?.items || []);

  const onRowClick = (id: number | string) => {
    navigate(`/promo/prizes/${id}`);
  };

  return (
    <DataTableBackendPagination<TablePrizeItemType>
      title="Список призов"
      data={tableData || []}
      total={prizes?.total || 0}
      pagination={pagination}
      setPagination={setPagination}
      columnConfig={columnConfig}
      onRowClick={(id) => onRowClick(id)}
      emptyListTitle="Пока, список призов пуст"
    />
  );
};
